import { config } from 'config';
import { PetType } from 'constants/pet-type';
import { COMMON_PAGE_PATHS_BY_REGION } from 'config/common-page-paths';
import { Region } from 'constants/shop';

/**
 * Check if url is absolute url. Useful to determine if it's internal link or not
 */
export const isAbsoluteUrl = (url: string): boolean => {
  try {
    new URL(url); // if `url` is invalid, throw an erorr
    return true;
  } catch {
    return false;
  }
};

export const isValidRedirect = (url: string): boolean => {
  if (url.startsWith('/') && !url.startsWith('//')) {
    return true;
  }

  if (!isAbsoluteUrl(url)) {
    return false;
  }

  const redirectUrl = new URL(url);
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';

  if (redirectUrl.origin === currentOrigin) {
    return true;
  }

  return (
    config.trustedRedirectDomains.includes(redirectUrl.hostname) &&
    redirectUrl.protocol === 'https:'
  );
};

interface GetHomeLink {
  petType: PetType | undefined;
  region: Region;
}

export const getHomeLink = ({ petType, region }: GetHomeLink): string => {
  const paths = COMMON_PAGE_PATHS_BY_REGION[region];

  switch (petType) {
    case PetType.Dog:
      return paths.dogsHome;
    case PetType.Cat:
      return paths.catsHome;
    default:
      return '/';
  }
};
